import {Quill} from 'react-quill';
import { loadInstagramScript } from './instagram/loadInstagramScript';
import { cleanInstagramPostURL } from './instagram/instagramUtils';


const BlockEmbed = Quill.import('blots/block/embed');

class InstagramBlot extends BlockEmbed {
	static create(data) {

		const cleanedUrl = cleanInstagramPostURL(data.url);

		const node = super.create(data);

        const innerHTML = `
        <div style="display: flex; max-width: 100%;" contentEditable="false">
          <blockquote class="instagram-media" data-instgrm-permalink="${cleanedUrl}" data-instgrm-version="12">
            <a href="${cleanedUrl}" tabIndex="-1">Voir le post Instagram</a>
          </blockquote>
        </div>
      `;
	
		node.innerHTML = innerHTML;
		node.setAttribute('data-url', cleanedUrl);

        loadInstagramScript()
        .then(() => {
            if (window.instgrm && window.instgrm.Embeds) {
                window.instgrm.Embeds.process();
            }
        })
        .catch(error => console.error('Erreur de chargement du script Instagram:', error));

		return node;
	}

	static value(domNode) {
		const { url } = domNode.dataset;
		return { url };
	}

	index() {
		return 1;
	}

}

InstagramBlot.blotName = 'instagram';
InstagramBlot.tagName = 'div';
InstagramBlot.className = 'ql-instagram';

Quill.register(InstagramBlot)

export default InstagramBlot